/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EntityIconKinds {
    Product = 10,
    Customer = 20,
}
